/**
 * SupportedFormatsInfo - Shows supported import formats when auto-detect handles all
 *
 * Displays a simple info block listing supported formats when the user
 * doesn't need to manually select a source format.
 */
import type { ReactElement } from 'react';
import { FaInfoCircle } from 'react-icons/fa';

// ============================================================================
// Types
// ============================================================================

export interface SupportedFormatsInfoProps {
  /** List of format names that are supported */
  formats: string[];
  /** Optional label (default: "Supported formats") */
  label?: string;
}

// ============================================================================
// Component
// ============================================================================

export default function SupportedFormatsInfo({ formats, label = 'Supported formats' }: SupportedFormatsInfoProps): ReactElement {
  return (
    <div className="border-storm bg-slate/30 flex items-start gap-3 rounded-lg border p-3">
      <FaInfoCircle className="text-aether mt-0.5 h-4 w-4 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-silver text-sm font-medium">{label}</p>
        <p className="text-ash mt-0.5 text-xs">{formats.join(', ')}</p>
      </div>
    </div>
  );
}
